module.exports = __webpack_public_path__ + "static/img/qx.f271c95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/qx.png
// module id = OZeN
// module chunks = 18